export const IVI_STEADY_THRESHOLD = 0.2;
export const IVI_VARIES_THRESHOLD = 0.4;
export const EVI_STEADY_THRESHOLD = 0.15;
export const EVI_VARIES_THRESHOLD = 0.25;
